import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import SignIn from '~/pages/SignIn';
import SignUp from '~/pages/SignUp';
import Recovery from '~/pages/Recovery';

import AppHome from '~/pages/app/Home';
import AppAbout from '~/pages/app/About';
import AppCart from '~/pages/app/Cart';
import AppCheckout from '~/pages/app/Checkout';
import AppOrders from '~/pages/app/Orders';
import AppHomeCategory from '~/pages/app/HomeCategory';

import AdminSignIn from '~/pages/admin/SignIn';
import { Test } from '~/pages/Test';

const IndexRoutes: React.FC = () => {
  return (
    <Switch>
      {/* AUTH */}
      <Route path="/" exact component={SignIn} />
      <Route path="/sign-in" component={SignIn} />
      <Route path="/sign-up" component={SignUp} />
      <Route path="/recovery" component={Recovery} />
      <Route path="/admin/sign-in" component={AdminSignIn} />

      <Route path="/test" exact component={Test} />

      {/* APP */}
      <Route path="/:id" exact component={AppHome} />
      <Route path="/:id/about" component={AppAbout} />
      <Route path="/:id/cart" component={AppCart} />
      <Route path="/:id/checkout" component={AppCheckout} />
      <Route path="/:id/orders" component={AppOrders} />
      <Route path="/:id/category/:category" component={AppHomeCategory} />

      <Route path="*" component={SignIn} />
    </Switch>
  );
};

export default IndexRoutes;
